/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _map from 'lodash/map'

import { get_event } from '../../../_common/core/selectors'

const DISCOUNT_OPTIONS = {
  fixed_discount: 'Fixed Discount',
  fixed_price: 'Fixed Price',
  percentage: 'Percentage Discount',
  none: 'No Discount',
}

@connect(
  state => ({
    user: state.auth.user,
    event: get_event(state),
  }),
  {},
)
export default class PromotionItem extends React.Component {
  static propTypes = {
    id: PropTypes.any.isRequired,
    showTypeLabel: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      item: props.item,
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    })
  }

  delete() {
    if (this.props.onDelete) {
      this.props.onDelete()
    }
  }

  render() {
    const { event, hadAdditionalCurrencies } = this.props
    const { item } = this.state
    const currency = getCurrencySymbol(event)

    return (
        <tr className="eventpromotion-item">
          <td>
            {item.ticketName}
            {this.props.showTypeLabel && (
              <span style={{ marginLeft: '5px', color: item.isTable === '1' ? '#9b59b6' : '#3498db', fontWeight: 'bold', fontSize: '11px' }}>
                {item.isTable === '1' ? '(Table)' : '(Ticket)'}
              </span>
            )}
            {!this.props.showTypeLabel && item.isTable === '1' && (
              <span style={{ marginLeft: '5px', color: '#9b59b6', fontWeight: 'bold', fontSize: '11px' }}>
                (Table)
              </span>
            )}
          </td>
          <td>{DISCOUNT_OPTIONS[item.discountType]}</td>
          <td>
            {item.discountType !== 'none' && item.discountType === 'percentage' && (
              <span>{item.discountValue}%</span>
            )}
            {item.discountType !== 'none' && item.discountType !== 'percentage' ? (
              hadAdditionalCurrencies && item?.currencies?.length ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                  {_map(
                    [
                      { currency: event?.currency?.currency, discountValue: item.discountValue },
                      ...item.currencies,
                    ],
                    currencyItem => (
                      <span>
                        {currencyItem.currency} {currencyItem.discountValue}
                      </span>
                    ),
                  )}
                </div>
              ) : (
                <span>
                  {currency} {item.discountValue}
                </span>
              )
            ) : (
              ''
            )}
          </td>
          {!this.props.shareMaxLimitChecked && (
           <td>{!!item.quantityLimit && <span>{item.quantityLimit}</span>}</td>
          )}
          <td className="align-right">
            <div
              aria-hidden
              className="eventpromotion-item-button eventpromotion-item-button-delete"
              onClick={e => this.delete()}
            >
              <i className="fa fa-trash" aria-hidden="true" />
            </div>
          </td>
        </tr>
    )
  }
}
